export const getCurrentGreetingMessage = () => {
  const data = [
    [0, 4, "Good Night"],
    [5, 11, "Good Morning"], //Store messages in an array
    [12, 17, "Good Afternoon"],
    [18, 24, "Good Night"],
  ];
  const hr = new Date().getHours();
  let greetingMessage = "";
  for (var i = 0; i < data.length; i++) {
    if (hr >= data[i][0] && hr <= data[i][1]) {
      greetingMessage = data[i][2];
    }
  }
  return greetingMessage;
};
